import React from "react";

import CustomSelect from "../../../../../components/elements/CustomSelect";
import InputField from "../../../../../components/elements/InputField";
import Button from "../../../../../components/elements/Button";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import TagsInput from "../../../../../components/elements/TagsInput";
import CodeEditor from "../../../../../components/elements/CodeEditor";


export default function ValidationCheckEditor({

                                                  check,

                                                  allowedChecks,

                                                  path,

                                                  updateAtPath,

                                                  onDelete

                                              }) {

    const set = (field, value) => {

        updateAtPath(
            [...path, field],
            value
        );

    };


    return (

        <div className="border rounded-md bg-gray-50 p-5 flex flex-col gap-5">


            {/* -------------------------------------------------
                Check Header
            ------------------------------------------------- */}

            <div className="flex items-center gap-5">

                <CustomSelect

                    className="flex-1"

                    value={check.kind}

                    options={allowedChecks}

                    onChange={(e) =>
                        set(
                            "kind",
                            e.target.value
                        )
                    }

                />


                <Button onClick={onDelete}>

                    <FontAwesomeIcon icon={faTrash}/>

                </Button>

            </div>


            {/* -------------------------------------------------
                PROGRAM
            ------------------------------------------------- */}


            {
                [

                    "stdout_exact",
                    "stdout_contains",
                    "stderr_exact",
                    "stderr_contains",
                    "exit_code"

                ].includes(check.kind) && (

                    <InputField

                        title="Expected"

                        value={check.expected || ""}

                        onChange={(e) =>
                            set(
                                "expected",
                                e.target.value
                            )
                        }

                    />

                )
            }


            {
                check.kind === "stdout_regex" && (

                    <InputField

                        title="Regex"

                        value={check.pattern || ""}

                        onChange={(e) =>
                            set(
                                "pattern",
                                e.target.value
                            )
                        }

                    />

                )
            }


            {/* -------------------------------------------------
                VARIABLE EQUALS
            ------------------------------------------------- */}

            {
                check.kind === "variable_equals" && (

                    <>

                        <InputField

                            title="Variable"

                            value={check.variable || ""}

                            onChange={(e) =>
                                set(
                                    "variable",
                                    e.target.value
                                )
                            }

                        />


                        <CustomSelect
                            title="Type"
                            value={check.kind_type || ""}
                            options={[
                                {
                                    value: "string",
                                    label: "String"
                                },
                                {
                                    value: "int",
                                    label: "Integer"
                                },
                                {
                                    value: "float",
                                    label: "Float"
                                },
                                {
                                    value: "number",
                                    label: "Number"
                                },
                                {
                                    value: "boolean",
                                    label: "Boolean"
                                },
                                {
                                    value: "list",
                                    label: "List"
                                },
                                {
                                    value: "dict",
                                    label: "Dictionary"
                                },
                                {
                                    value: "undefined",
                                    label: "Undefined"
                                }
                            ]}
                            onChange={(e) =>
                                set(
                                    "kind_type",
                                    e.target.value
                                )
                            }
                        />


                        <InputField

                            title="Expected"

                            value={check.expected || ""}

                            onChange={(e) =>
                                set(
                                    "expected",
                                    e.target.value
                                )
                            }

                        />

                    </>

                )
            }

            {/* -------------------------------------------------
    VARIABLE TYPE
------------------------------------------------- */}

            {
                check.kind === "variable_type" && (

                    <>

                        <InputField
                            title="Variable"
                            value={check.variable || ""}
                            onChange={(e) =>
                                set(
                                    "variable",
                                    e.target.value
                                )
                            }
                        />

                        <CustomSelect
                            title="Expected Type"
                            value={check.expected || ""}
                            options={[
                                {
                                    value: "string",
                                    label: "String"
                                },
                                {
                                    value: "int",
                                    label: "Integer"
                                },
                                {
                                    value: "float",
                                    label: "Float"
                                },
                                {
                                    value: "number",
                                    label: "Number"
                                },
                                {
                                    value: "boolean",
                                    label: "Boolean"
                                },
                                {
                                    value: "list",
                                    label: "List"
                                },
                                {
                                    value: "dict",
                                    label: "Dictionary"
                                },
                                {
                                    value: "null",
                                    label: "Null"
                                },
                                {
                                    value: "undefined",
                                    label: "Undefined"
                                }
                            ]}
                            onChange={(e) =>
                                set(
                                    "expected",
                                    e.target.value
                                )
                            }
                        />

                    </>

                )
            }

            {/* -------------------------------------------------
                VARIABLE EXISTS
            ------------------------------------------------- */}

            {
                check.kind === "variable_exists" && (

                    <InputField

                        title="Variable"

                        value={check.variable || ""}

                        onChange={(e) =>
                            set(
                                "variable",
                                e.target.value
                            )
                        }

                    />

                )
            }
            {/* -------------------------------------------------
    PYTHON LIST
------------------------------------------------- */}

            {
                check.kind === "list_equals" && (

                    <>

                        <InputField
                            title="Variable"
                            value={check.variable || ""}
                            onChange={(e) =>
                                set(
                                    "variable",
                                    e.target.value
                                )
                            }
                        />

                        <InputField
                            title="Expected List"
                            placeholder='[]'
                            value={check.expected || ""}
                            onChange={(e) =>
                                set(
                                    "expected",
                                    e.target.value
                                )
                            }
                        />

                    </>

                )
            }


            {
                check.kind === "list_exists" && (

                    <InputField
                        title="Variable"
                        value={check.variable || ""}
                        onChange={(e) =>
                            set(
                                "variable",
                                e.target.value
                            )
                        }
                    />

                )
            }

            {/* -------------------------------------------------
    PYTHON CONDITION
------------------------------------------------- */}

            {
                check.kind === "python_check_condition" && (

                    <>

                        <CustomSelect
                            title="Condition Type"
                            value={check.type || ""}
                            options={[
                                {
                                    value: "if",
                                    label: "If"
                                },
                                {
                                    value: "elif",
                                    label: "Else If"
                                },
                                {
                                    value: "else",
                                    label: "Else"
                                }
                            ]}
                            onChange={(e) => {

                                const value = e.target.value;

                                set("type", value);

                                // Else has no condition
                                if (value === "else") {

                                    updateAtPath(
                                        [...path, "condition"],
                                        undefined
                                    );

                                }

                            }}
                        />

                        {
                            ["if", "elif"].includes(check.type) && (

                                <InputField
                                    title="Condition"
                                    placeholder="x == 8"
                                    value={check.condition || ""}
                                    onChange={(e) =>
                                        set(
                                            "condition",
                                            e.target.value
                                        )
                                    }
                                />

                            )
                        }

                        <div className="flex flex-col gap-2">

                            <label className="text-sm font-medium text-gray-700">
                                Block
                            </label>

                            <CodeEditor
                                value={check.block || ""}
                                language="python"
                                onChange={(newCode) =>
                                    set(
                                        "block",
                                        newCode
                                    )
                                }
                            />

                        </div>

                    </>

                )
            }

            {/* -------------------------------------------------
                COMMENT
            ------------------------------------------------- */}

            {
                check.kind === "comment" && (

                    <>

                        <CustomSelect

                            title="Comment Type"

                            value={check.type || ""}

                            options={[
                                {
                                    value: "",
                                    label: "Any Type"
                                },
                                {
                                    value: "line",
                                    label: "Line Comment"
                                },
                                {
                                    value: "inline",
                                    label: "Inline Comment"
                                },
                                {
                                    value: "docstring",
                                    label: "Docstring"
                                }
                            ]}

                            onChange={(e) => {

                                const value = e.target.value;

                                if (value === "") {

                                    updateAtPath(
                                        [...path, "type"],
                                        undefined
                                    );

                                    return;
                                }

                                set(
                                    "type",
                                    value
                                );

                            }}

                        />


                        <InputField

                            title="Comment Text"

                            value={check.text || ""}

                            onChange={(e) =>
                                set(
                                    "text",
                                    e.target.value
                                )
                            }

                        />


                        <InputField

                            title="Line Number"

                            type="number"

                            min={1}

                            value={
                                check.line === undefined
                                    ? ""
                                    : check.line
                            }

                            onChange={(e) => {

                                const value = e.target.value;

                                set(
                                    "line",
                                    value === ""
                                        ? undefined
                                        : Number(value)
                                );

                            }}

                        />

                    </>

                )
            }


            {/* -------------------------------------------------
                SQL
            ------------------------------------------------- */}

            {
                check.kind === "row_count" && (

                    <InputField

                        title="Row Count"

                        type="number"

                        value={check.count || 0}

                        onChange={(e) =>
                            set(
                                "count",
                                Number(e.target.value)
                            )
                        }

                    />

                )
            }


            {
                check.kind === "columns_exact" && (

                    <InputField

                        title="Columns (comma separated)"

                        value={
                            (check.columns || [])
                                .join(",")
                        }

                        onChange={(e) =>
                            set(
                                "columns",
                                e.target.value
                                    .split(",")
                                    .map(c => c.trim())
                            )
                        }

                    />

                )
            }


            {/* -------------------------------------------------
    WEB
------------------------------------------------- */}

            {
                [
                    "selector_exists",
                    "selector_count",
                    "tag_exists",
                    "tag_count",
                    "tag_with_class_exists",
                    "tag_with_id_exists",
                    "text_exact",
                    "attribute_equals",
                    "css_property_equals",
                    "selector_matches"
                ].includes(check.kind) && (

                    <InputField
                        title={
                            [
                                "tag_exists",
                                "tag_count",
                                "tag_with_class_exists",
                                "tag_with_id_exists"
                            ].includes(check.kind)
                                ? "Tag / Selector"
                                : "Selector"
                        }
                        value={check.selector || ""}
                        onChange={(e) =>
                            set(
                                "selector",
                                e.target.value
                            )
                        }
                    />

                )
            }


            {
                [
                    "selector_count",
                    "tag_count"
                ].includes(check.kind) && (

                    <InputField
                        title="Count"
                        type="number"
                        min={0}
                        value={
                            check.count === undefined
                                ? ""
                                : check.count
                        }
                        onChange={(e) =>
                            set(
                                "count",
                                e.target.value === ""
                                    ? undefined
                                    : Number(e.target.value)
                            )
                        }
                    />

                )
            }


            {
                check.kind === "tag_with_class_exists" && (

                    <InputField
                        title="Class Name"
                        value={check.className || ""}
                        onChange={(e) =>
                            set(
                                "className",
                                e.target.value
                            )
                        }
                    />

                )
            }


            {
                check.kind === "tag_with_id_exists" && (

                    <InputField
                        title="ID"
                        value={check.id || ""}
                        onChange={(e) =>
                            set(
                                "id",
                                e.target.value
                            )
                        }
                    />

                )
            }


            {
                check.kind === "text_exact" && (

                    <InputField
                        title="Expected Text"
                        value={check.expected || ""}
                        onChange={(e) =>
                            set(
                                "expected",
                                e.target.value
                            )
                        }
                    />

                )
            }


            {
                check.kind === "attribute_equals" && (

                    <>

                        <InputField
                            title="Attribute"
                            value={check.attribute || ""}
                            onChange={(e) =>
                                set(
                                    "attribute",
                                    e.target.value
                                )
                            }
                        />

                        <InputField
                            title="Expected"
                            value={check.expected || ""}
                            onChange={(e) =>
                                set(
                                    "expected",
                                    e.target.value
                                )
                            }
                        />

                    </>

                )
            }


            {
                check.kind === "css_property_equals" && (

                    <>

                        <InputField
                            title="CSS Property"
                            value={check.property || ""}
                            onChange={(e) =>
                                set(
                                    "property",
                                    e.target.value
                                )
                            }
                        />

                        <InputField
                            title="Expected"
                            value={check.expected || ""}
                            onChange={(e) =>
                                set(
                                    "expected",
                                    e.target.value
                                )
                            }
                        />

                    </>

                )
            }


            {
                check.kind === "selector_matches" && (

                    <InputField
                        title="Selector"
                        value={check.selector || ""}
                        onChange={(e) =>
                            set(
                                "selector",
                                e.target.value
                            )
                        }
                    />

                )
            }


            {/* -------------------------------------------------
    JAVASCRIPT
------------------------------------------------- */}

            {
                check.kind === "js_variable_equals" && (

                    <>

                        <InputField
                            title="Variable"
                            value={check.variable || ""}
                            onChange={(e) =>
                                set(
                                    "variable",
                                    e.target.value
                                )
                            }
                        />

                        <InputField
                            title="Expected"
                            value={check.expected || ""}
                            onChange={(e) =>
                                set(
                                    "expected",
                                    e.target.value
                                )
                            }
                        />

                    </>

                )
            }


            {
                check.kind === "js_expression_equals" && (

                    <>

                        <InputField
                            title="Expression"
                            value={check.expression || ""}
                            onChange={(e) =>
                                set(
                                    "expression",
                                    e.target.value
                                )
                            }
                        />

                        <InputField
                            title="Expected"
                            value={check.expected || ""}
                            onChange={(e) =>
                                set(
                                    "expected",
                                    e.target.value
                                )
                            }
                        />

                    </>

                )
            }


            {
                check.kind === "event_fired" && (

                    <InputField
                        title="Event"
                        value={check.event || ""}
                        onChange={(e) =>
                            set(
                                "event",
                                e.target.value
                            )
                        }
                    />

                )
            }


            {
                [
                    "console_exact",
                    "console_contains"
                ].includes(check.kind) && (

                    <InputField
                        title="Expected"
                        value={check.expected || ""}
                        onChange={(e) =>
                            set(
                                "expected",
                                e.target.value
                            )
                        }
                    />

                )
            }


            {
                [
                    "local_storage_equals",
                    "session_storage_equals"
                ].includes(check.kind) && (

                    <>

                        <InputField
                            title="Key"
                            value={check.key || ""}
                            onChange={(e) =>
                                set(
                                    "key",
                                    e.target.value
                                )
                            }
                        />

                        <InputField
                            title="Expected"
                            value={check.expected || ""}
                            onChange={(e) =>
                                set(
                                    "expected",
                                    e.target.value
                                )
                            }
                        />

                    </>

                )
            }


        </div>

    );

}